import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { addDays, format } from 'date-fns';

const AddDays: React.FC = () => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [daysToAdd, setDaysToAdd] = useState<string>('0');
  const [resultDate, setResultDate] = useState<string>('');
  const [daysError, setDaysError] = useState<string>('');

  const handleCalculate = () => {
    if (!selectedDate) {
      setResultDate('Please select a starting date.');
      return;
    }
    const numDays = parseInt(daysToAdd, 10);
    if (isNaN(numDays)) {
      setDaysError('Please enter a valid number of days.');
      setResultDate('');
      return;
    }
    setDaysError('');
    const newDate = addDays(selectedDate, numDays);
    setResultDate(format(newDate, 'EEEE, MMMM do, yyyy'));
  };

  const handleDaysChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setDaysToAdd(value);
    if (value.trim() === '' || !/^-?\d+$/.test(value)) {
        setDaysError('Please enter a valid integer for days.');
    } else {
        setDaysError('');
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Add Days to Date
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
        <DatePicker
          label="Select Start Date"
          value={selectedDate}
          onChange={(newValue) => setSelectedDate(newValue)}
          slots={{ textField: (params) => <TextField {...params} fullWidth /> }}
        />
        <TextField
          label="Days to Add (or subtract with -)"
          type="text" // Changed to text to allow custom validation for integer
          value={daysToAdd}
          onChange={handleDaysChange}
          error={!!daysError}
          helperText={daysError}
          fullWidth
        />
        <Button variant="contained" onClick={handleCalculate} disabled={!!daysError || !selectedDate || daysToAdd.trim() === ''}>
          Calculate New Date
        </Button>
        {resultDate && (
          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            Result: <strong>{resultDate}</strong>
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default AddDays;
